import Vue from 'vue' // 导入vue
import Main from './main.vue' // 导入组件

// 将组件作为参数，使用vue提供的全局方法，创建一个构造函数
let pzDialogConstructor = Vue.extend(Main)

let instance

/**
 *
 * @param {*} content 内容
 * @param {*} title 标题
 * @param {*} options 选项
 * @param {*} _this 当前组件实例
 * @returns
 */
const pzDialog = function (options, _this) {
	// 初始化实例，此时instance是一个组件实例，但未初始化未完成,这里的变量和方法优先组件内的变量和方法
	instance = new pzDialogConstructor({
		provide() {
			return {
				dialogInstance: _this // 提供当前组件实例
			}
		},
		data() {
			return {
				visible: false,
				content: options.content,
				title: options.title || '提示',
				onConfirm: options.onConfirm,
				onCancel: options.onCancel,
				// https://element.eleme.cn/#/zh-CN/component/dialog#attributes
				options: {
					/**
					 * 类型
					 * 当类型值为 form 时，为表单弹窗，底部按钮会隐藏取消和提交两个按钮，通过你自己定义的表单按钮控制弹窗的关闭
					 */
					type: '',
					// 是否传入组件
					component: null,
					//注入组件的数据
					componentData: null,
					// 宽度
					width: '386px',
					top: '35vh',
					// 标题是否居中
					titleCenter: true,
					// 内容是否居中
					contentCenter: false,
					// 按钮是否居中
					buttonCenter: true,
					// 按钮顺序是否反转
					buttonReverse: false,
					// 是否可以通过按下 ESC 关闭 Dialog
					closeOnPressEscape: false,
					// 是否可以通过点击 modal 关闭 Dialog
					closeOnClickModal: false,
					// Dialog 的自定义类名
					customClass: '',
					// 是否显示底部(如果是表单导入组件建议为 false)
					showFooter: true,
					// 是否显示右上角关闭按钮
					showClose: false,
					// 关闭时销毁 Dialog 中的元素
					destroyOnClose: true,
					// 取消按钮的文本内容
					cancelButtonText: '取消',
					// 是否显示取消按钮
					showCancelButton: true,
					// 确定按钮的文本内容
					confirmButtonText: '确定',
					...options
				}
			}
		},
		methods: {
			/**
			 * 确定按钮
			 * callback 回调函数
			 * callback.close 关闭弹窗
			 * options.type.form 判断是否是表单组件
			 */
			confirm(e) {
				this.onConfirm(e)
			},
			cancel() {
				this.onCancel()
			}
		}
	})
	// 卸载组件
	instance.remove = () => {
		instance.visible = false
	}
	// 完成初始化
	instance.$mount()
	// 将组件添加到根节点body
	document.body.appendChild(instance.$el)
	// 显示组件
	instance.visible = true
	return instance
}

export default pzDialog
